import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Bullet from "../../Bullet";
import Gun from "../../Gun";
import Player from "../../Player";

export default class TwinMachineGun extends Gun {

    constructor(player: Player) {
        super(player, {
            damage: 10,
            fireRate: 6,
            magSize: 40,
            reloadTime: 2,
            bulletSpeed: 200,
            mouseTrigger: 0
        })
    }

    onShoot(): void {
        const centerSpawnPos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
        const pos1 = centerSpawnPos.add(this.player.transform.left.scale(4));
        const pos2 = centerSpawnPos.add(this.player.transform.right.scale(4));
        const vel = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));

        this.player.engine.createBulletForAll(pos1, vel, [
            {
                key: "team",
                value: this.player.team || "",
                type: PacketValueSerialType.String
            },
            {
                key: "damage",
                value: this.damage,
                type: PacketValueSerialType.Byte
            },
            {
                key: "ownerName",
                value: this.player.name,
                type: PacketValueSerialType.String
            },
        ]);
        this.player.engine.createBulletForAll(pos2, vel, [
            {
                key: "team",
                value: this.player.team || "",
                type: PacketValueSerialType.String
            },
            {
                key: "damage",
                value: this.damage,
                type: PacketValueSerialType.Byte
            },
            {
                key: "ownerName",
                value: this.player.name,
                type: PacketValueSerialType.String
            },
        ]);
    }

}